export const environment = {

  production: false,
  faroEnvironment: 'aca-dgag-passport-dev',
  // Azure AD / MSAL
  clientId: '42c03d7a-2404-4071-a56d-53dd176d9c69',
  tenantId: '59fa7797-abec-4505-81e6-8ce092642190',
 
  apiBaseUrl: '',
  apiUrl: '',
  /** When empty, `/system-status.json` is used. Set to absolute URL for remote ops-controlled JSON. */
  systemStatusUrl: '',
  redirectUri: 'https://dev-passport.mccain.com/sso',
  postLogoutRedirectUri: 'https://dev-passport.mccain.com/',
 
  // redirectUri: 'http://localhost:4200/sso',
  // postLogoutRedirectUri: 'http://localhost:4200/',
  // apiBaseUrl: 'http://localhost:5273',
  // apiUrl: 'http://localhost:5273',
};